"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatFileToFileResult = void 0;
var download_email_filename_1 = require("./download-email-filename");
function formatFileToFileResult(file, handleFileDownload, handleFileArchive, handleFileUnarchive) {
    var _this = this;
    var _a = file, id = _a.id, filename = _a.filename, meta = _a.meta, status = _a.status, createdAt = _a.createdAt, updatedAt = _a.updatedAt, createdByUserId = _a.createdByUserId, updatedByUserId = _a.updatedByUserId, objectRefs = _a.objectRefs, category = _a.category;
    var objectReferenceTypes = [];
    var objectReferenceIds = [];
    var isEmail = (category === null || category === void 0 ? void 0 : category.toLowerCase()) === 'email';
    var _loop_1 = function (type, ids) {
        // eslint-disable-next-line no-unused-expressions
        ids === null || ids === void 0 ? void 0 : ids.forEach(function (referenceId) {
            objectReferenceTypes.push(type);
            objectReferenceIds.push(referenceId);
        });
    };
    // eslint-disable-next-line no-restricted-syntax
    for (var _i = 0, _b = Object.entries(objectRefs !== null && objectRefs !== void 0 ? objectRefs : {}); _i < _b.length; _i++) {
        var _c = _b[_i], type = _c[0], ids = _c[1];
        _loop_1(type, ids);
    }
    return {
        fileId: id,
        fileName: filename,
        summary: meta === null || meta === void 0 ? void 0 : meta.summary,
        createdAt: new Date(createdAt).toISOString(),
        createdByUserId: createdByUserId,
        updatedAt: new Date(updatedAt).toISOString(),
        updatedByUserId: updatedByUserId,
        associations: null,
        objectReferenceTypes: objectReferenceTypes,
        objectReferenceIds: objectReferenceIds,
        status: status,
        category: category,
        download: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, handleFileDownload(id, 'attachment', false, isEmail ? (0, download_email_filename_1.getDownloadEmailFilename)(id, filename) : undefined)];
        }); }); },
        preview: function (newTab) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, handleFileDownload(id, 'inline', newTab || false, filename)];
        }); }); },
        archive: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, handleFileArchive(id)];
        }); }); },
        unarchive: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, handleFileUnarchive(id)];
        }); }); },
    };
}
exports.formatFileToFileResult = formatFileToFileResult;
